var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDigitalProductionFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-digitalProductionFrame"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-digitalProductionFrame",
    clipPath: "url(#clip-icon-digitalProductionFrame)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M868.52,66.35H155.48a89.134,89.134,0,0,0-89.13,89.13V868.52a89.134,89.134,0,0,0,89.13,89.13H868.52a89.134,89.134,0,0,0,89.13-89.13V155.48A89.134,89.134,0,0,0,868.52,66.35ZM474.888,761.341a35.649,35.649,0,0,1-35.652,35.652H194.129a35.656,35.656,0,0,1-35.652-35.652V629.774a35.657,35.657,0,0,1,35.652-35.652H439.236a35.65,35.65,0,0,1,35.652,35.652Zm0-268.437a35.642,35.642,0,0,1-35.652,35.652H194.129A35.649,35.649,0,0,1,158.477,492.9V361.348A35.656,35.656,0,0,1,194.129,325.7H439.236a35.649,35.649,0,0,1,35.652,35.652ZM865.512,761.341a35.649,35.649,0,0,1-35.652,35.652H584.752A35.657,35.657,0,0,1,549.1,761.341V629.774a35.657,35.657,0,0,1,35.652-35.652H829.86a35.65,35.65,0,0,1,35.652,35.652Zm0-268.437a35.642,35.642,0,0,1-35.652,35.652H584.752A35.65,35.65,0,0,1,549.1,492.9V361.348A35.657,35.657,0,0,1,584.752,325.7H829.86a35.649,35.649,0,0,1,35.652,35.652Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDigitalProductionFrame);
export default __webpack_public_path__ + "static/media/icon-digitalProductionFrame.b4e6540c5a9aca4d83ac9350fecdc3ea.svg";
export { ForwardRef as ReactComponent };